import React from 'react'
import { Col, Form, FormCheckProps, Row } from 'react-bootstrap'

interface FormSwitchProps extends FormCheckProps {
	name: string
	checked: boolean
	label?: string
	required?: boolean
	feedback?: string
	type?: FormCheckProps['type']
	switchLabel?: string
	labelCol?: number | 'auto'
	labelJustify?: 'start' | 'end' | 'center' | 'between' | 'around'
	controlJustify?: 'start' | 'end' | 'center' | 'between' | 'around'
}

const FormSwitch = (props: FormSwitchProps) => {
	const { switchLabel, labelCol, labelJustify, controlJustify, ...htmlProps } = props

	const control = (
		<>
			<Form.Check
				type={props.type || 'switch'}
				{...htmlProps}
				label={switchLabel || ''}
				onChange={(e) => !props.readOnly && props.onChange && props.onChange(e)}
				className="mb-0"
			/>
			{props.feedback ? <Form.Control.Feedback type="invalid">{props.feedback}</Form.Control.Feedback> : null}
		</>
	)

	return (
		<Form.Group controlId={props.name} as={labelCol ? Row : undefined} className={labelCol ? 'align-items-center' : undefined}>
			{props.label ? (
				<Form.Label
					column={labelCol ? true : undefined}
					sm={labelCol || undefined}
					className={labelJustify ? `d-flex justify-content-${labelJustify}` : undefined}
				>
					{`${props.label}${props.required ? ' *' : ''}`}
				</Form.Label>
			) : null}

			{labelCol ? (
				<Col
					sm={typeof labelCol === 'number' ? 12 - labelCol : undefined}
					className={controlJustify ? `d-flex justify-content-${controlJustify}` : undefined}
				>
					{control}
				</Col>
			) : (
				control
			)}
		</Form.Group>
	)
}

export { FormSwitch }
